import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {ThemeContext, Icon} from '../../../common';
import treasureImg from '../../../../images/treasure.png';
import {getResizeImagePaths, onImageError} from '../../../../utils';

export default class UserTreasures extends PureComponent {
  static propTypes = {
    treasures: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      asset: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
      }),
      points: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    })),
    fetchUserTreasures: PropTypes.func.isRequired,
    availablePoints: PropTypes.number,
  };

  static defaultProps = {
    treasures: [],
    availablePoints: 0,
  };

  componentDidMount() {
    this.props.fetchUserTreasures();
  }

  renderTreasure = ({
    name,
    asset: {
      title,
      url = treasureImg,
    },
    points,
    description,
    status = 'PENDING',
  }, idx, theme) => {
    const color = theme.secondaryColor;
    const backgroundColor = theme.primaryColor;
    const statusIcons = {
      PENDING: 'hourglass-start',
      APPROVED: 'thumbs-up',
      REJECTED: 'thumbs-down',
    };
    const statusIcon = statusIcons[status] || 'hourglass-start';
    const headerClasses = classnames(
      'row user-treasures__treasure__header',
      {
        'user-treasures__treasure__header_rejected': status === 'REJECTED',
        'user-treasures__treasure__header_pending': status === 'PENDING',
      }
    );
    const descriptionClasses = classnames(
      'row user-treasures__treasure__description',
      {
        'user-treasures__treasure__description_rejected': status === 'REJECTED',
        'user-treasures__treasure__description_pending': status === 'PENDING',
      }
    );
    const {defaultImageURL, resizedImageURL} = getResizeImagePaths(url, 100);

    return (
      <div className="row row_space-between user-treasures__treasure" key={`_${idx}`}>
        <div className="cell cell_auto">
          <figure className="treasure">
            <div
              className="treasure__image-wrap row row_vcenter row_center"
            >
              <img
                className="treasure__image"
                src={resizedImageURL}
                onError={onImageError(defaultImageURL)}
                alt={title}
                title={title}
              />
            </div>
            <figcaption className="treasure__name">{name}</figcaption>
            <div className="treasure__points" style={{color}}>
              YakGold:&nbsp;
              <b>{points}</b>
            </div>
            <div
              className="user-treasures__treasure__status"
              style={{backgroundColor}}
              title={status}
            >
              <Icon glyph={statusIcon} iconSize="28"/>
            </div>
          </figure>
        </div>
        <div className="cell treasure__desc">
          <div className={headerClasses}>Description:</div>
          <div className={descriptionClasses}>{description}</div>
        </div>
      </div>
    );
  };

  render() {
    const {treasures, availablePoints} = this.props;
    return (
      <ThemeContext.Consumer>
        {theme => (
          <Fragment>
            <h3 className="user-profile__points" style={{color: theme.secondaryColor}}>
              YakGold available for redemption:&nbsp;
              <span>{availablePoints}</span>
            </h3>
            {
              treasures.map(((treasure, idx) => (
                treasure.asset && this.renderTreasure(treasure, idx, theme)
              )))
            }
          </Fragment>
        )}
      </ThemeContext.Consumer>
    );
  }
}
